<template>
  <div class="mc-upload">
    <div v-if="totalFailed === 0" class="mc-upload-result mc-upload-result--success">
      <figure>
        <img src="@/assets/images/success-icon.png" alt />
      </figure>
      <h4 class="mc-upload-result__label">
        {{ $t('global.importResult.successUpload') }}
      </h4>
      <ul class="mc-upload-result__detail">
        <li>
          <b>{{ totalSuccess + totalFailed }}</b> {{ $t('global.importResult.total') }}
        </li>
        <li class="text-success">
          <b>{{ totalSuccess }}</b> {{ $t('global.importResult.successData') }}
        </li>
        <li class="text-danger">
          <b>{{ totalFailed }}</b> {{ $t('global.importResult.failedData') }}
        </li>
      </ul>
    </div>
    <div
      v-else-if="totalFailed > 0 && totalSuccess > 0"
      class="mc-upload-result mc-upload-result--warning"
    >
      <figure>
        <img src="@/assets/images/warning-icon.png" alt />
      </figure>
      <h4 class="mc-upload-result__label">
        {{ $t('global.importResult.partialSuccess') }}
      </h4>
      <ul class="mc-upload-result__detail">
        <li>
          <b>{{ totalSuccess + totalFailed }}</b> {{ $t('global.importResult.total') }}
        </li>
        <li class="text-success">
          <b>{{ totalSuccess }}</b> {{ $t('global.importResult.successData') }}
        </li>
        <li class="text-danger">
          <b>{{ totalFailed }}</b> {{ $t('global.importResult.failedData') }}
        </li>
      </ul>
      <McButton
        variant="secondary"
        icon="icon-outline_download"
        :text="$t('global.importResult.failedDownload')"
        @click="toDownload"
      />
    </div>
    <div v-else-if="totalSuccess === 0" class="mc-upload-result mc-upload-result--error">
      <figure>
        <img src="@/assets/images/alert-report-danger.png" alt />
      </figure>
      <h4 class="mc-upload-result__label">
        {{ $t('global.importResult.failedUpload') }}
      </h4>
      <ul class="mc-upload-result__detail">
        <li>
          <b>{{ totalSuccess + totalFailed }}</b> {{ $t('global.importResult.total') }}
        </li>
        <li class="text-success">
          <b>{{ totalSuccess }}</b> {{ $t('global.importResult.successData') }}
        </li>
        <li class="text-danger">
          <b>{{ totalFailed }}</b> {{ $t('global.importResult.failedData') }}
        </li>
      </ul>
      <McButton
        variant="secondary"
        icon="icon-outline_download"
        :text="$t('global.importResult.failedDownload')"
        @click="toDownload"
      />
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
export default {
  components: {
    McButton,
  },
  props: {
    totalFailed: {
      type: Number,
      required: false,
    },
    totalSuccess: {
      type: Number,
      required: false,
    },
    totalData: {
      type: Number,
      required: false,
    },
    errorFile: {
      type: String,
      required: false,
    },
    fileName: {
      type: String,
      required: false,
    },
    fileType: {
      type: String,
      required: false,
    },
  },
  methods: {
    toDownload() {
      var temp = 'data:' + this.fileType + ';base64,' + encodeURIComponent(this.errorFile)
      var download = document.createElement('a')
      download.href = temp
      download.download = 'data_gagal_' + this.fileName
      document.body.appendChild(download)
      download.click()
      document.body.removeChild(download)
    },
  },
}
</script>
